var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fade-transition',[(_vm.showSplashScreen)?_c('splash',{attrs:{"message":_vm.message}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }